import { ref, computed, watch } from 'vue'
import { animateDef } from '@/constants/animations/logo'

const animationTimer = 130
export const useAnimatedLogo = () => {
    const triggered = ref(true)
    const animateIndx = ref(0)
    const bars = ref([
        {
            x: 0,
            y: 13,
            height: 53
        },
        {
            x: 16,
            y: 0,
            height: 79
        },
        {
            x: 32,
            y: 9,
            height: 61
        },
        {
            x: 48,
            y: 18,
            height: 43
        },
        {
            x: 64,
            y: 28,
            height: 23
        }
    ])

    watch(
        () => animateIndx.value,
        async (index) => {
            if (index === 0 && triggered.value) {
                await animate()
            }
        }
    )
    async function animate() {
        for (let i = 0; i < animateDef.length; i++) {
            if (!triggered.value) break
            await _timeout(animationTimer)

            animateIndx.value = i === animateDef.length - 1 ? 0 : i + 1
            while (_shouldUpdate.value) {
                await _timeout(0)
                _updateFirstBar()
                _updateSecondBar()
                _updateThirdBar()
                _updateFourthBar()
                _updateFifthBar()
            }
        }
    }

    const _animation = computed(() => animateDef[animateIndx.value])
    const _firstAnimateY = computed(() => _animation.value[0].y)
    const _secondAnimateY = computed(() => _animation.value[1].y)
    const _thirdAnimateY = computed(() => _animation.value[2].y)
    const _fourthAnimateY = computed(() => _animation.value[3].y)
    const _fifthAnimateY = computed(() => _animation.value[4].y)

    const _firstAnimateHeight = computed(() => _animation.value[0].height)
    const _secondAnimateHeight = computed(() => _animation.value[1].height)
    const _thirdAnimateHeight = computed(() => _animation.value[2].height)
    const _fourthAnimateHeight = computed(() => _animation.value[3].height)
    const _fifthAnimateHeight = computed(() => _animation.value[4].height)

    const _firstYDiff = computed(() => Math.abs(_firstAnimateY.value - bars.value[0].y))
    const _secondYDiff = computed(() => Math.abs(_secondAnimateY.value - bars.value[1].y))
    const _thirdYDiff = computed(() => Math.abs(_thirdAnimateY.value - bars.value[2].y))
    const _fourthYDiff = computed(() => Math.abs(_fourthAnimateY.value - bars.value[3].y))
    const _fifthYDiff = computed(() => Math.abs(_fifthAnimateY.value - bars.value[4].y))

    const _firstHeightDiff = computed(() => Math.abs(_firstAnimateHeight.value - bars.value[0].height))
    const _secondHeightDiff = computed(() => Math.abs(_secondAnimateHeight.value - bars.value[1].height))
    const _thirdHeightDiff = computed(() => Math.abs(_thirdAnimateHeight.value - bars.value[2].height))
    const _fourthHeightDiff = computed(() => Math.abs(_fourthAnimateHeight.value - bars.value[3].height))
    const _fifthHeightDiff = computed(() => Math.abs(_fifthAnimateHeight.value - bars.value[4].height))

    const _shouldUpdate = computed(() => {
        return (
            _firstYDiff.value !== 0 ||
            _secondYDiff.value !== 0 ||
            _thirdYDiff.value !== 0 ||
            _fourthYDiff.value !== 0 ||
            _fifthYDiff.value !== 0 ||
            _firstHeightDiff.value !== 0 ||
            _secondHeightDiff.value !== 0 ||
            _thirdHeightDiff.value !== 0 ||
            _fourthHeightDiff.value !== 0 ||
            _fifthHeightDiff.value !== 0
        )
    })

    function _timeout(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms))
    }
    function _updateFirstBar() {
        if (_firstAnimateY.value > bars.value[0].y) {
            bars.value[0].y = bars.value[0].y + 1
        } else if (_firstAnimateY.value < bars.value[0].y) {
            bars.value[0].y = bars.value[0].y - 1
        }

        if (_firstAnimateHeight.value > bars.value[0].height) {
            bars.value[0].height = bars.value[0].height + 1
        } else if (_firstAnimateHeight.value < bars.value[0].height) {
            bars.value[0].height = bars.value[0].height - 1
        }
    }
    function _updateSecondBar() {
        if (_secondAnimateY.value > bars.value[1].y) {
            bars.value[1].y = bars.value[1].y + 1
        } else if (_secondAnimateY.value < bars.value[1].y) {
            bars.value[1].y = bars.value[1].y - 1
        }

        if (_secondAnimateHeight.value > bars.value[1].height) {
            bars.value[1].height = bars.value[1].height + 1
        } else if (_secondAnimateHeight.value < bars.value[1].height) {
            bars.value[1].height = bars.value[1].height - 1
        }
    }
    function _updateThirdBar() {
        if (_thirdAnimateY.value > bars.value[2].y) {
            bars.value[2].y = bars.value[2].y + 1
        } else if (_thirdAnimateY.value < bars.value[2].y) {
            bars.value[2].y = bars.value[2].y - 1
        }

        if (_thirdAnimateHeight.value > bars.value[2].height) {
            bars.value[2].height = bars.value[2].height + 1
        } else if (_thirdAnimateHeight.value < bars.value[2].height) {
            bars.value[2].height = bars.value[2].height - 1
        }
    }
    function _updateFourthBar() {
        if (_fourthAnimateY.value > bars.value[3].y) {
            bars.value[3].y = bars.value[3].y + 1
        } else if (_fourthAnimateY.value < bars.value[3].y) {
            bars.value[3].y = bars.value[3].y - 1
        }

        if (_fourthAnimateHeight.value > bars.value[3].height) {
            bars.value[3].height = bars.value[3].height + 1
        } else if (_fourthAnimateHeight.value < bars.value[3].height) {
            bars.value[3].height = bars.value[3].height - 1
        }
    }
    function _updateFifthBar() {
        if (_fifthAnimateY.value > bars.value[4].y) {
            bars.value[4].y = bars.value[4].y + 1
        } else if (_fifthAnimateY.value < bars.value[4].y) {
            bars.value[4].y = bars.value[4].y - 1
        }

        if (_fifthAnimateHeight.value > bars.value[4].height) {
            bars.value[4].height = bars.value[4].height + 1
        } else if (_fifthAnimateHeight.value < bars.value[4].height) {
            bars.value[4].height = bars.value[4].height - 1
        }
    }

    return { bars, triggered, animate }
}
